<template>
	<div class="wrapper" @click="toggleCheck">
		<ui-image :src="user.image" :alt="user.name" design="circle" h="40" />
		<div class="info">
			<div class="info name">{{ user.name }}</div>
			<div class="info group">{{ user.group }}</div>
		</div>

		<div class="circle-check" :class="checkboxClass">
			<em v-show="check" class="fal fa-check"></em>
		</div>
	</div>
</template>

<script>
	import { uiImage } from '@/components/ui'

	export default {
		name: 'user-wrapper-item',
		components: { uiImage },

		props: {
			value: {
				type: Boolean,
				required: true,
			},

			checked: {
				type: Boolean,
				required: true,
			},

			user: {
				type: Object,
				required: true,
			},
		},

		data() {
			return {
				check: false,
			}
		},

		mounted() {
			this.check = this.checked
		},

		methods: {
			toggleCheck() {
				this.check = !this.check
			},
		},

		computed: {
			checkboxClass() {
				return {
					active: this.check,
				}
			},
		},

		watch: {
			value(value) {
				this.check = value
			},

			check(value) {
				this.$emit('input', value)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
